// external
import type { Store } from 'redux';

// libraries
import { BaseMiddleware } from '@makemydeal/dr-activities-common';

// store
import type { Selectors } from './selectors';
import type { HostActions } from './hostActions';
import { VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS } from './actions';
import { extractQueryParams } from '../utils/queryUtils';
export class MiddlewareManager extends BaseMiddleware {
    constructor(
        public selectors: Selectors,
        public hostActions?: HostActions,
        public baseRoute?: string,
        public analyticsAction?: (store: any, key: string, desc: string) => void
    ) {
        super(selectors, analyticsAction);
    }

    /**
     * any activity specific middleware code should be defined here;
     * application-specific middleware should be outside of the activity
     */
    protected middlewareFunction = (store: Store<any>, next: any, action: any): void => {
        switch (action.type) {
            case VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS: {
                if (this.hostActions) {
                    if (action.payload?.success) {
                        // Navigate to the dashboard where role assumption will be active
                        store.dispatch(this.hostActions!.navigateToDashboard());
                    } else {
                        // Set the isValidRoleAssumptionUser to false to show error message
                        const queryString = extractQueryParams(window.location.search);
                        store.dispatch(this.hostActions.clearRoleAssumption(`?${queryString}`));
                    }
                }
                break;
            }
            default: {
                break;
            }
        }
    };
}
